<template>
    <div class="design_studio_panel_pd design-history-panel">
        <a href="javascript:;" @click="goBack" class="back-link">
            <img
                src="/maincss/images/tool_back_arrow.svg"
                alt="Back"
                class="mr-2"
            />
            Back
        </a>
        <div>
            <!-- Design Details Section -->
            <div class="design-details-section" v-if="design">
                <div class="design-header-section">
                    <div class="design_top_main">
                        <div class="design-title-section">
                            <h3 class="design-name">{{ design.name }}</h3>
                            <p class="upload-date">
                                Uploaded On {{ formatDate(design.createdAt) }}
                            </p>
                        </div>
                        <div class="design-thumbnails">
                            <div
                                class="thumbnail-item"
                                v-if="design.front_image"
                            >
                                <div class="thumb_img_box">
                                    <img
                                        :src="design.front_image"
                                        alt="Front"
                                    />
                                     <div class="product_art_info">
                                        <!-- <p>SP</p> -->
                                         <ul
                                        class="thumbnail-colors"
                                        v-if="
                                            getThumbnailColors(
                                                design.front_color,
                                                'front'
                                            ).length > 0
                                        "
                                    >
                                        <li
                                            v-for="(
                                                color, index
                                            ) in getThumbnailColors(
                                                design.front_color,
                                                'front'
                                            )"
                                            :key="index"
                                            :style="{
                                                backgroundColor: color.hex
                                            }"
                                        ></li>
                                        <li
                                            v-if="
                                                getThumbnailMoreCount(
                                                    design.front_color,
                                                        'front'
                                                ) > 0
                                            "
                                            class="more_color_link"
                                        >
                                            <a href="javascript:;">
                                                +{{
                                                    getThumbnailMoreCount(
                                                        design.front_color,
                                                        'front'
                                                    )
                                                }}
                                            </a>
                                        </li>
                                    </ul>
                                     </div>
                                </div>
                                <div>
                                    <span class="thumbnail-dir-label"> <img
                src="/maincss/images/design-studio/F.svg"
                alt="front"
                class="mr-2"
            /></span>
                                  
                                </div>
                            </div>
                            <div
                                class="thumbnail-item"
                                v-if="design.back_image"
                            >
                                <div class="thumb_img_box">
                                    <img :src="design.back_image" alt="Back" />
                                    <div class="product_art_info">
                                        <!-- <p>SP</p> -->
                                     <ul
                                        class="thumbnail-colors"
                                        v-if="
                                            getThumbnailColors(
                                                design.back_color,
                                                'back'
                                            ).length > 0
                                        "
                                    >
                                        <li
                                            v-for="(
                                                color, index
                                            ) in getThumbnailColors(
                                                design.back_color,
                                                'back'
                                            )"
                                            :key="index"
                                            :style="{
                                                backgroundColor: color.hex
                                            }"
                                        ></li>
                                        <li
                                            v-if="
                                                getThumbnailMoreCount(
                                                    design.back_color,
                                                        'back'
                                                ) > 0
                                            "
                                            class="more_color_link"
                                        >
                                            <a href="javascript:;">
                                                +{{
                                                    getThumbnailMoreCount(
                                                        design.back_color,
                                                        'back'
                                                    )
                                                }}
                                            </a>
                                        </li>
                                    </ul>
                                    </div>
                                </div>
                                <div>
                                    <span class="thumbnail-dir-label"> <img
                src="/maincss/images/design-studio/B.svg"
                alt="Back"
                class="mr-2"
            /></span>
                                   
                                </div>
                            </div>
                            <div
                                class="thumbnail-item"
                                v-if="design.left_image"
                            >
                                <div class="thumb_img_box">
                                    <img :src="design.left_image" alt="Left" />
                                    <div class="product_art_info">
                                        <!-- <p>SP</p> -->
                                     <ul
                                        class="thumbnail-colors"
                                        v-if="
                                            getThumbnailColors(
                                                design.left_color,
                                                'left'
                                            ).length > 0
                                        "
                                    >
                                        <li
                                            v-for="(
                                                color, index
                                            ) in getThumbnailColors(
                                                design.left_color,
                                                'left'
                                            )"
                                            :key="index"
                                            :style="{
                                                backgroundColor: color.hex
                                            }"
                                        ></li>
                                        <li
                                            v-if="
                                                getThumbnailMoreCount(
                                                    design.left_color,
                                                        'left'
                                                ) > 0
                                            "
                                            class="more_color_link"
                                        >
                                            <a href="javascript:;">
                                                +{{
                                                    getThumbnailMoreCount(
                                                        design.left_color,
                                                        'left'
                                                    )
                                                }}
                                            </a>
                                        </li>
                                    </ul>
                                    </div>
                                </div>
                                <div>
                                    <span class="thumbnail-dir-label"><img
                src="/maincss/images/design-studio/L.svg"
                alt="Left"
                class="mr-2"
            /></span>
                                   
                                </div>
                            </div>
                            <div
                                class="thumbnail-item"
                                v-if="design.right_image"
                            >
                                <div class="thumb_img_box">
                                    <img
                                        :src="design.right_image"
                                        alt="Right"
                                    />
                                    <div class="product_art_info">
                                        <!-- <p>SP</p> -->
                                       <ul
                                        class="thumbnail-colors"
                                        v-if="
                                            getThumbnailColors(
                                                design.right_color,
                                                'right'
                                            ).length > 0
                                        "
                                    >
                                        <li
                                            v-for="(
                                                color, index
                                            ) in getThumbnailColors(
                                                design.right_color,
                                                'right'
                                            )"
                                            :key="index"
                                            :style="{
                                                backgroundColor: color.hex
                                            }"
                                        ></li>
                                        <li
                                            v-if="
                                                getThumbnailMoreCount(
                                                    design.right_color,
                                                        'right'
                                                ) > 0
                                            "
                                            class="more_color_link"
                                        >
                                            <a href="javascript:;">
                                                +{{
                                                    getThumbnailMoreCount(
                                                        design.right_color,
                                                        'right'
                                                    )
                                                }}
                                            </a>
                                        </li>
                                    </ul>
                                    </div>
                                </div>
                                <div>
                                    <span class="thumbnail-dir-label"><img
                src="/maincss/images/design-studio/R.svg"
                alt="Right"
                class="mr-2"
            /></span>
                                 
                                </div>
                            </div>
                        </div>
                        <div class="design-actions">
                            <button
                                class="btn btn-danger btn-sm delete-btn"
                                @click="deleteDesign"
                            >
                                DELETE
                            </button>
                        </div>
                    </div>
                    <div class="note_panel" v-if="design.archive_note">Notes: {{ design.archive_note }}</div>
                </div>
            </div>

            <!-- Order History Section -->
            <div class="order-history-section">
                <h4 class="order-history-title">
                    Artwork Order History ({{ orders.length }})
                </h4>
                <div v-if="isLoader" class="text-center p-4">
                    <p>Loading orders...</p>
                </div>
                <div
                    v-else-if="orders.length === 0"
                    class="no-orders text-center p-4"
                >
                    <p>No orders found for this design.</p>
                </div>
                <div v-else class="orders-list" id="design-history-accordion">
                    <div
                        v-for="(order, index) in orders"
                        :key="order.id"
                        class="order-entry panel panel-default"
                    >
                        <button
                            class="order-header panel-heading d-flex justify-content-between align-items-center w-100 text-left collapsed"
                            :id="'order-heading-' + order.id"
                            role="tab"
                            data-toggle="collapse"
                            :data-parent="'#design-history-accordion'"
                            :href="'#order-body-' + order.id"
                            :aria-controls="'order-body-' + order.id"
                            :aria-expanded="index === 0 ? 'true' : 'false'"
                            :class="{ collapsed: index !== 0 }"
                            type="button"
                        >
                            <div>
                                <h5>#{{ order.unique_order_id }}</h5>
                                
                            </div>
                            <div class="history_right_block">

                                <p class="order-date">
                                    Ordered On {{ formatDate(order.created_at) }}
                                </p>
                                <svg width="12" height="7" viewBox="0 0 12 7" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M0.75 0.75L5.75 5.75L10.75 0.75" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                    </svg>
                            </div>
                        </button>
                        <div
                            class="order-content panel-collapse collapse"
                            :class="{ in: index === 0 }"
                            :id="'order-body-' + order.id"
                            role="tabpanel"
                            :aria-labelledby="'order-heading-' + order.id"
                        >
                            <div class="panel-body p-0">
                                <OrderDetailsDesignHistory
                                    :order_data="getProcessedOrderData(order)"
                                    :total_non_standard_colors="[]"
                                    :hideTotals="true"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ApiService from "@/common/api.service";
import OrderDetailsDesignHistory from "@/components/payments/OrderDetailsDesignHistory.vue";

export default {
    name: "DesignHistory",
    components: {
        OrderDetailsDesignHistory
    },
    props: {
        designId: {
            type: [Number, String],
            required: true
        }
    },
    data() {
        return {
            isLoader: false,
            design: null,
            orders: [],
            orderColorsBySide: {
                front: [],
                back: [],
                left: [],
                right: []
            }
        };
    },
    mounted() {
        document.body.classList.add("my-design");
        this.fetchDesignDetails();
        this.fetchOrders();
    },
    beforeUnmount() {
        document.body.classList.remove("my-design");
    },
    watch: {
        designId() {
            if (this.designId) {
                this.fetchDesignDetails();
                this.fetchOrders();
            }
        }
    },
    methods: {
        normalizeDesignId(source) {
            if (!source) return null;
            return (
                source.saved_design_id ||
                source.design_id ||
                source.id ||
                null
            );
        },
        async fetchDesignDetails() {
            if (!this.designId) return;
            this.isLoader = true;
            try {
                const { data } = await ApiService.get(
                    "/get-single-design/" + this.designId
                );
                this.design = data.design;
            } catch (error) {
                this.$toast.error("Failed to load design details", {
                    position: "top-right"
                });
            } finally {
                this.isLoader = false;
            }
        },
        async fetchOrders() {
            if (!this.designId) return;
            this.isLoader = true;
            try {
                const primaryDesignId = this.normalizeDesignId({
                    id: this.designId
                });
                const { data } = await ApiService.get(
                    "/get-orders-by-design-id/" + primaryDesignId
                );
                const primaryOrders = Array.isArray(data.orders)
                    ? data.orders
                    : [];

                // Some split/new payloads carry the effective design id as saved_design_id.
                // Retry once with that id if primary result is empty.
                const fallbackDesignId = this.normalizeDesignId(this.design);
                if (
                    primaryOrders.length === 0 &&
                    fallbackDesignId &&
                    String(fallbackDesignId) !== String(primaryDesignId)
                ) {
                    const { data: fallbackData } = await ApiService.get(
                        "/get-orders-by-design-id/" + fallbackDesignId
                    );
                    this.orders = Array.isArray(fallbackData.orders)
                        ? fallbackData.orders
                        : [];
                } else {
                    this.orders = primaryOrders;
                }

                // Build per-side swatch fallback from order data (name/number colors live here)
                this.orderColorsBySide = this.buildOrderColorsBySide(
                    this.orders || []
                );
            } catch (error) {
                this.$toast.error("Failed to load order history", {
                    position: "top-right"
                });
            } finally {
                this.isLoader = false;
            }
        },
        formatDate(dateString) {
            if (!dateString) return "";
            const date = new Date(dateString);
            const months = [
                "Jan",
                "Feb",
                "Mar",
                "Apr",
                "May",
                "Jun",
                "Jul",
                "Aug",
                "Sep",
                "Oct",
                "Nov",
                "Dec"
            ];
            return `${
                months[date.getMonth()]
            } ${date.getDate()}, ${date.getFullYear()}`;
        },
        isJSON(str) {
            try {
                JSON.parse(str);
                return true;
            } catch (error) {
                return false;
            }
        },
        parseJSONValue(value, fallback = null) {
            if (value === null || value === undefined || value === "") {
                return fallback;
            }
            if (typeof value === "string") {
                try {
                    return JSON.parse(value);
                } catch (error) {
                    return fallback;
                }
            }
            return value;
        },
        ensureArray(value) {
            if (Array.isArray(value)) return value;
            if (value && typeof value === "object") return [value];
            return [];
        },
        getThumbnailColors(colors, sideKey = null) {
            const normalized = this.normalizeThumbnailColors(colors);
            if (normalized.length > 0) return normalized.slice(0, 4);

            // If design colors are missing, fallback to order-derived colors for that side
            if (
                sideKey &&
                this.orderColorsBySide &&
                Array.isArray(this.orderColorsBySide[sideKey]) &&
                this.orderColorsBySide[sideKey].length > 0
            ) {
                return this.orderColorsBySide[sideKey].slice(0, 4);
            }
            return [];
        },
        getThumbnailMoreCount(colors, sideKey = null) {
            const normalized = this.normalizeThumbnailColors(colors);
            if (normalized.length > 0) return Math.max(0, normalized.length - 4);

            if (
                sideKey &&
                this.orderColorsBySide &&
                Array.isArray(this.orderColorsBySide[sideKey]) &&
                this.orderColorsBySide[sideKey].length > 0
            ) {
                return Math.max(0, this.orderColorsBySide[sideKey].length - 4);
            }
            return 0;
        },
        normalizeThumbnailColors(colors) {
            if (!colors || colors === null || colors === "null") return [];

            let colorsParse = [];
            if (Array.isArray(colors)) {
                colorsParse = colors;
            } else if (this.isJSON(colors)) {
                try {
                    colorsParse = JSON.parse(colors);
                } catch (e) {
                    return [];
                }
            } else {
                return [];
            }

            if (!Array.isArray(colorsParse) || colorsParse.length === 0) {
                return [];
            }

            return colorsParse
                .map((c) => {
                    const hex = this.extractHexFromAnyColor(c);
                    return hex ? { hex } : null;
                })
                .filter(Boolean);
        },
        extractHexFromAnyColor(color) {
            if (!color) return null;

            // sometimes API returns an array of hex strings
            if (typeof color === "string") return color;

            if (typeof color !== "object") return null;

            const tryFromObj = (obj) => {
                if (!obj || typeof obj !== "object") return null;
                return (
                    obj.hex ||
                    obj.color_value ||
                    obj.colorValue ||
                    obj.color_hex ||
                    obj.hex_color ||
                    obj.color_hex_code ||
                    obj.color_code ||
                    obj.hexCode ||
                    obj.colorCode ||
                    obj.color_hex_code ||
                    obj.hex_code ||
                    (obj.color && tryFromObj(obj.color)) ||
                    (obj.color_value && obj.color_value) ||
                    null
                );
            };

            const hex = tryFromObj(color);
            return typeof hex === "string" ? hex : null;
        },
        buildOrderColorsBySide(orders) {
            const out = {
                front: [],
                back: [],
                left: [],
                right: []
            };
            const seen = {
                front: new Set(),
                back: new Set(),
                left: new Set(),
                right: new Set()
            };

            const addHex = (side, hex) => {
                if (!hex || !side) return;
                const key = String(hex).toLowerCase().trim();
                if (!key) return;
                if (!seen[side].has(key)) {
                    seen[side].add(key);
                    out[side].push({ hex });
                }
            };

            const normalizeSide = (raw) => {
                if (!raw) return null;
                const s = String(raw).toLowerCase().trim();
                if (s === "f" || s.indexOf("front") === 0) return "front";
                if (s === "b" || s.indexOf("back") === 0) return "back";
                if (s === "l" || s.indexOf("left") === 0) return "left";
                if (s === "r" || s.indexOf("right") === 0) return "right";
                return null;
            };

            // Iterate a few recent orders; swatches should match since design is same
            (orders || []).slice(0, 5).forEach((order) => {
                try {
                    const processed = this.getProcessedOrderData(order);
                    const items = (processed && processed.items) || [];
                    items.forEach((item) => {
                        let imprintLocations = [];
                        if (item && item.imprint_locations) {
                            try {
                                imprintLocations =
                                    typeof item.imprint_locations === "string"
                                        ? JSON.parse(item.imprint_locations)
                                        : item.imprint_locations;
                                if (!Array.isArray(imprintLocations))
                                    imprintLocations = [];
                            } catch (e) {
                                imprintLocations = [];
                            }
                        }

                        imprintLocations.forEach((loc) => {
                            const side = normalizeSide(
                                loc &&
                                    (loc.code ||
                                        loc.location ||
                                        loc.label ||
                                        loc.view)
                            );
                            if (!side) return;
                            const colorsArr =
                                (loc && (loc.colors || loc.standard_colors)) ||
                                [];
                            (colorsArr || []).forEach((c) => {
                                const hex = this.extractHexFromAnyColor(c);
                                addHex(side, hex);
                            });
                        });
                    });
                } catch (e) {
                    // ignore bad order payload
                }
            });

            return out;
        },
        closePanel() {
            document.body.classList.remove("my-design");
            this.$emit("close-history");
        },
        goBack() {
            document.body.classList.remove("my-design");
            this.$emit("close-history");
        },
        deleteDesign() {
            if (confirm("Do you really want to delete this design?")) {
                this.isLoader = true;
                ApiService.delete("/delete-saved-design/" + this.designId)
                    .then(() => {
                        this.$toast.success("Design deleted successfully", {
                            position: "top-right"
                        });
                        this.closePanel();
                    })
                    .catch(({ response }) => {
                        this.$toast.error("Failed to delete design", {
                            position: "top-right"
                        });
                        this.isLoader = false;
                    });
            }
        },
        getProcessedOrderData(order) {
            // Process order data to match OrderDetails component format
            let processedOrder = JSON.parse(JSON.stringify(order));
            let order_items = [];
            let all_setup_fee = 0;

            if (
                processedOrder.NewOrderItems &&
                processedOrder.NewOrderItems.length > 0
            ) {
                processedOrder.NewOrderItems.forEach((item) => {
                    // Handle both MainNewSubProduct (singular) and MainNewSubProducts (plural)
                    let subProduct =
                        item.MainNewSubProduct || item.MainNewSubProducts;

                    if (subProduct) {
                        // Handle both MainNewProducts (singular) and MainNewProducts (plural)
                        let mainProduct =
                            subProduct.MainNewProducts ||
                            subProduct.MainNewProduct;

                        if (mainProduct) {
                            let item_setup_fee = parseFloat(
                                item.setup_fee || 0
                            );

                            // Create order_item from MainNewProducts
                            let order_item = {
                                ...mainProduct
                            };

                            // Ensure essential properties
                            if (!order_item.id) {
                                order_item.id = subProduct.parent_product_id;
                            }
                            if (!order_item.name && order_item.product_number) {
                                order_item.name = order_item.product_number;
                            }

                            order_item.color = subProduct.Color;
                            order_item["NewOrderItemDecoration"] =
                                item.NewOrderItemDecorations &&
                                item.NewOrderItemDecorations.length > 0
                                    ? item.NewOrderItemDecorations[0]
                                    : null;

                            // Find if this product/color combination already exists
                            let index = order_items.findIndex(
                                (item_data) =>
                                    item_data.id ==
                                        subProduct.parent_product_id &&
                                    item_data.color &&
                                    item_data.color.id == subProduct.color_id
                            );

                            if (index >= 0 && order_items[index]) {
                                // Add to existing group
                                order_items[index]["sizes"].push(item);
                                order_items[index]["total_quantity"] +=
                                    parseInt(item.quantity || 0);
                                order_items[index]["total_price"] +=
                                    parseFloat(item.total_price || 0) +
                                    parseFloat(item.discount || 0);
                                order_items[index]["total_discount"] +=
                                    parseFloat(item.discount || 0);

                                if (item.item_sub_total) {
                                    if (!order_items[index]["item_sub_total"]) {
                                        order_items[index][
                                            "item_sub_total"
                                        ] = 0;
                                    }
                                    order_items[index]["item_sub_total"] +=
                                        parseFloat(item.item_sub_total || 0);
                                }

                                // Copy breakdown fields from any size that has them
                                // Check if existing value is empty/null/undefined or has no data
                                if (item.base_fee) {
                                    const parsedBaseFee =
                                        typeof item.base_fee === "string"
                                            ? JSON.parse(item.base_fee)
                                            : item.base_fee;

                                    // If existing is empty/null/undefined or empty array, replace it
                                    if (
                                        !order_items[index]["base_fee"] ||
                                        (Array.isArray(
                                            order_items[index]["base_fee"]
                                        ) &&
                                            order_items[index]["base_fee"]
                                                .length === 0)
                                    ) {
                                        order_items[index]["base_fee"] =
                                            parsedBaseFee;
                                    }
                                }
                                if (item.run_charge_breakdown) {
                                    const parsedRunCharge =
                                        typeof item.run_charge_breakdown ===
                                        "string"
                                            ? JSON.parse(
                                                  item.run_charge_breakdown
                                              )
                                            : item.run_charge_breakdown;

                                    // If existing is empty/null/undefined or empty array, replace it
                                    if (
                                        !order_items[index][
                                            "run_charge_breakdown"
                                        ] ||
                                        (Array.isArray(
                                            order_items[index][
                                                "run_charge_breakdown"
                                            ]
                                        ) &&
                                            order_items[index][
                                                "run_charge_breakdown"
                                            ].length === 0)
                                    ) {
                                        order_items[index][
                                            "run_charge_breakdown"
                                        ] = parsedRunCharge;
                                    }
                                }
                                if (item.rush_fee_breakdown) {
                                    const parsedRushFee =
                                        typeof item.rush_fee_breakdown ===
                                        "string"
                                            ? JSON.parse(
                                                  item.rush_fee_breakdown
                                              )
                                            : item.rush_fee_breakdown;

                                    // If existing is empty/null/undefined, replace it
                                    if (
                                        !order_items[index][
                                            "rush_fee_breakdown"
                                        ] ||
                                        (parsedRushFee &&
                                            typeof parsedRushFee === "object" &&
                                            parsedRushFee.total !== undefined &&
                                            parsedRushFee.total !== null)
                                    ) {
                                        order_items[index][
                                            "rush_fee_breakdown"
                                        ] = parsedRushFee;
                                    }
                                }
                                if (item.setup_fees_details) {
                                    const parsedSetupFees =
                                        typeof item.setup_fees_details ===
                                        "string"
                                            ? JSON.parse(
                                                  item.setup_fees_details
                                              )
                                            : item.setup_fees_details;

                                    // If existing is empty/null/undefined or empty object, replace it
                                    if (
                                        !order_items[index][
                                            "setup_fees_details"
                                        ] ||
                                        (typeof order_items[index][
                                            "setup_fees_details"
                                        ] === "object" &&
                                            !order_items[index][
                                                "setup_fees_details"
                                            ].total) ||
                                        (parsedSetupFees &&
                                            typeof parsedSetupFees ===
                                                "object" &&
                                            parsedSetupFees.total !==
                                                undefined &&
                                            parsedSetupFees.total !== null)
                                    ) {
                                        order_items[index][
                                            "setup_fees_details"
                                        ] = parsedSetupFees;
                                    }
                                }
                                if (item.custom_color_fee) {
                                    const parsedCustomColorFee =
                                        typeof item.custom_color_fee ===
                                        "string"
                                            ? JSON.parse(item.custom_color_fee)
                                            : item.custom_color_fee;

                                    // If existing is empty/null/undefined or empty array, replace it
                                    if (
                                        !order_items[index][
                                            "custom_color_fee"
                                        ] ||
                                        (Array.isArray(
                                            order_items[index][
                                                "custom_color_fee"
                                            ]
                                        ) &&
                                            order_items[index][
                                                "custom_color_fee"
                                            ].length === 0)
                                    ) {
                                        order_items[index]["custom_color_fee"] =
                                            parsedCustomColorFee;
                                    }
                                }

                                // Copy NewOrderItemDecoration if not already set
                                if (
                                    !order_items[index][
                                        "NewOrderItemDecoration"
                                    ] &&
                                    item.NewOrderItemDecorations &&
                                    item.NewOrderItemDecorations.length > 0
                                ) {
                                    order_items[index][
                                        "NewOrderItemDecoration"
                                    ] = item.NewOrderItemDecorations[0];
                                }

                                // Copy decoration_colors if not already set or empty
                                if (
                                    (!order_items[index]["decoration_colors"] ||
                                        !Array.isArray(
                                            order_items[index][
                                                "decoration_colors"
                                            ]
                                        ) ||
                                        order_items[index]["decoration_colors"]
                                            .length === 0) &&
                                    item.decoration_colors
                                ) {
                                    order_items[index]["decoration_colors"] =
                                        typeof item.decoration_colors ===
                                        "string"
                                            ? JSON.parse(item.decoration_colors)
                                            : item.decoration_colors;
                                }

                                // Copy design_images and design_image if not already set or empty
                                if (
                                    (!order_items[index]["design_images"] ||
                                        !Array.isArray(
                                            order_items[index]["design_images"]
                                        ) ||
                                        order_items[index]["design_images"]
                                            .length === 0) &&
                                    item.design_image
                                ) {
                                    if (typeof item.design_image === "string") {
                                        try {
                                            order_items[index][
                                                "design_images"
                                            ] = JSON.parse(item.design_image);
                                            if (
                                                Array.isArray(
                                                    order_items[index][
                                                        "design_images"
                                                    ]
                                                ) &&
                                                order_items[index][
                                                    "design_images"
                                                ].length > 0
                                            ) {
                                                order_items[index][
                                                    "design_image"
                                                ] =
                                                    order_items[index][
                                                        "design_images"
                                                    ][0].url ||
                                                    order_items[index][
                                                        "design_images"
                                                    ][0].design_image ||
                                                    item.design_image;
                                            }
                                        } catch (e) {
                                            order_items[index][
                                                "design_images"
                                            ] = [];
                                        }
                                    } else {
                                        order_items[index]["design_images"] =
                                            [];
                                    }
                                }
                            } else {
                                // Create new group
                                order_item["sizes"] = [item];
                                order_item["total_quantity"] = parseInt(
                                    item.quantity || 0
                                );
                                order_item["setup_fee"] = item_setup_fee;
                                order_item["total_price"] =
                                    parseFloat(item.total_price || 0) +
                                    parseFloat(item.discount || 0);
                                order_item["total_discount"] = parseFloat(
                                    item.discount || 0
                                );
                                order_item["design_fee"] = parseFloat(
                                    item.design_fee || 0
                                );
                                order_item["name_number_fees"] = parseFloat(
                                    item.name_number_fees || 0
                                );
                                order_item["non_standard_fees"] = parseFloat(
                                    item.non_standard_fees || 0
                                );
                                order_item["item_sub_total"] =
                                    item.item_sub_total
                                        ? parseFloat(item.item_sub_total)
                                        : null;

                                // Parse breakdown fields
                                order_item["base_fee"] =
                                    this.parseJSONValue(item.base_fee, []) || [];
                                order_item["run_charge_breakdown"] =
                                    this.parseJSONValue(
                                        item.run_charge_breakdown,
                                        []
                                    ) || [];
                                order_item["rush_fee_breakdown"] =
                                    this.parseJSONValue(
                                        item.rush_fee_breakdown,
                                        null
                                    );
                                order_item["setup_fees_details"] =
                                    this.parseJSONValue(
                                        item.setup_fees_details,
                                        null
                                    );
                                order_item["custom_color_fee"] =
                                    this.parseJSONValue(
                                        item.custom_color_fee,
                                        []
                                    ) || [];

                                // Parse colors
                                order_item["non_standard_colors"] =
                                    this.ensureArray(
                                        this.parseJSONValue(
                                            item.non_standard_colors,
                                            []
                                        )
                                    );
                                order_item["decoration_colors"] =
                                    this.ensureArray(
                                        this.parseJSONValue(
                                            item.decoration_colors,
                                            []
                                        )
                                    );

                                // Parse imprint_locations
                                order_item["imprint_locations"] =
                                    this.ensureArray(
                                        this.parseJSONValue(
                                            item.imprint_locations,
                                            []
                                        )
                                    );
                                order_item["imprint_locations"] = order_item[
                                    "imprint_locations"
                                ].filter((location) => location.is_selected);
                                order_item["color_fee"] = 0;

                                // Parse name_and_number_json
                                order_item["name_and_number_json"] =
                                    this.ensureArray(
                                        this.parseJSONValue(
                                            item.name_and_number_json,
                                            []
                                        )
                                    );
                                order_item["name_and_number_json"] = order_item[
                                    "name_and_number_json"
                                ].filter(
                                    (nn) =>
                                        (nn.name && nn.name !== "") ||
                                        (nn.number && nn.number !== "")
                                );

                                // Parse design_image
                                if (item.design_image) {
                                    if (typeof item.design_image === "string") {
                                        try {
                                            order_item["design_images"] =
                                                JSON.parse(item.design_image);
                                            if (
                                                Array.isArray(
                                                    order_item["design_images"]
                                                ) &&
                                                order_item["design_images"]
                                                    .length > 0
                                            ) {
                                                order_item["design_image"] =
                                                    order_item[
                                                        "design_images"
                                                    ][0].url ||
                                                    order_item[
                                                        "design_images"
                                                    ][0].design_image ||
                                                    item.design_image;
                                            }
                                        } catch (e) {
                                            order_item["design_images"] = [];
                                        }
                                    }
                                } else {
                                    order_item["design_images"] = [];
                                }

                                // Add product_image
                                if (
                                    mainProduct &&
                                    mainProduct.MainNewProductImages
                                ) {
                                    if (
                                        mainProduct.MainNewProductImages
                                            .length > 0
                                    ) {
                                        order_item["product_image"] =
                                            mainProduct.MainNewProductImages.find(
                                                (img) =>
                                                    img.color_id ==
                                                    subProduct.color_id
                                            ) ||
                                            mainProduct.MainNewProductImages[0];
                                    }
                                }

                                // Calculate color_fee from imprint_locations
                                if (
                                    order_item["imprint_locations"] &&
                                    Array.isArray(
                                        order_item["imprint_locations"]
                                    )
                                ) {
                                    order_item["imprint_locations"].forEach(
                                        (location) => {
                                            order_item["color_fee"] +=
                                                parseFloat(
                                                    location[
                                                        "total_decoration_fee"
                                                    ] || 0
                                                );
                                            if (
                                                location.is_selected &&
                                                location.colors
                                            ) {
                                                location.colors.forEach(
                                                    (color) => {
                                                        order_item[
                                                            "color_fee"
                                                        ] += parseFloat(
                                                            color.total_decor_upcharge ||
                                                                0
                                                        );
                                                    }
                                                );
                                            }
                                        }
                                    );
                                }

                                order_items.push(order_item);
                            }

                            all_setup_fee += item_setup_fee;
                        }
                    }
                });

                // Calculate price breakups for each order_item
                order_items.forEach((order_item) => {
                    order_item.base_price = 0;
                    order_item.markup_price = 0;
                    order_item.markup_percentage = 0;
                    order_item.ink_price = 0;
                    order_item.single_location_price = 0;

                    if (order_item.sizes && Array.isArray(order_item.sizes)) {
                        order_item.sizes.forEach((size) => {
                            order_item.base_price +=
                                parseFloat(size.base_price || 0) *
                                parseInt(size.quantity || 0);
                            order_item.ink_price += parseFloat(
                                size.ink_price || 0
                            );
                            order_item.single_location_price = parseFloat(
                                size.single_location_price || 0
                            );
                            order_item.markup_price +=
                                parseFloat(size.markup_price || 0) *
                                parseInt(size.quantity || 0);
                            order_item.markup_percentage =
                                size.markup_percentage || 0;
                        });

                        order_item.ink_price =
                            parseFloat(order_item.ink_price) *
                            parseInt(order_item.total_quantity);
                        order_item.single_location_price =
                            parseFloat(order_item.single_location_price) *
                            parseInt(order_item.total_quantity);

                        // Ensure base_fee and run_charge_breakdown are set from any size that has them
                        // Check if order_item is missing these fields or has empty arrays
                        const hasBaseFee =
                            order_item["base_fee"] &&
                            Array.isArray(order_item["base_fee"]) &&
                            order_item["base_fee"].length > 0;

                        const hasRunCharge =
                            order_item["run_charge_breakdown"] &&
                            Array.isArray(order_item["run_charge_breakdown"]) &&
                            order_item["run_charge_breakdown"].length > 0;

                        // If missing, find first size that has the data
                        if (!hasBaseFee) {
                            for (const size of order_item.sizes) {
                                if (size.base_fee) {
                                    const parsedBaseFee =
                                        typeof size.base_fee === "string"
                                            ? JSON.parse(size.base_fee)
                                            : size.base_fee;
                                    if (
                                        parsedBaseFee &&
                                        Array.isArray(parsedBaseFee) &&
                                        parsedBaseFee.length > 0
                                    ) {
                                        order_item["base_fee"] = parsedBaseFee;
                                        break;
                                    }
                                }
                            }
                        }

                        if (!hasRunCharge) {
                            for (const size of order_item.sizes) {
                                if (size.run_charge_breakdown) {
                                    const parsedRunCharge =
                                        typeof size.run_charge_breakdown ===
                                        "string"
                                            ? JSON.parse(
                                                  size.run_charge_breakdown
                                              )
                                            : size.run_charge_breakdown;
                                    if (
                                        parsedRunCharge &&
                                        Array.isArray(parsedRunCharge) &&
                                        parsedRunCharge.length > 0
                                    ) {
                                        order_item["run_charge_breakdown"] =
                                            parsedRunCharge;
                                        break;
                                    }
                                }
                            }
                        }

                        // Check for setup_fees_details
                        const hasSetupFees =
                            order_item["setup_fees_details"] &&
                            typeof order_item["setup_fees_details"] ===
                                "object" &&
                            order_item["setup_fees_details"].total !==
                                undefined &&
                            order_item["setup_fees_details"].total !== null;

                        if (!hasSetupFees) {
                            for (const size of order_item.sizes) {
                                if (size.setup_fees_details) {
                                    const parsedSetupFees =
                                        typeof size.setup_fees_details ===
                                        "string"
                                            ? JSON.parse(
                                                  size.setup_fees_details
                                              )
                                            : size.setup_fees_details;
                                    if (
                                        parsedSetupFees &&
                                        typeof parsedSetupFees === "object" &&
                                        parsedSetupFees.total !== undefined &&
                                        parsedSetupFees.total !== null
                                    ) {
                                        order_item["setup_fees_details"] =
                                            parsedSetupFees;
                                        break;
                                    }
                                }
                            }
                        }

                        // Check for custom_color_fee
                        const hasCustomColorFee =
                            order_item["custom_color_fee"] &&
                            Array.isArray(order_item["custom_color_fee"]) &&
                            order_item["custom_color_fee"].length > 0;

                        if (!hasCustomColorFee) {
                            for (const size of order_item.sizes) {
                                if (size.custom_color_fee) {
                                    const parsedCustomColorFee =
                                        typeof size.custom_color_fee ===
                                        "string"
                                            ? JSON.parse(size.custom_color_fee)
                                            : size.custom_color_fee;
                                    if (
                                        parsedCustomColorFee &&
                                        Array.isArray(parsedCustomColorFee) &&
                                        parsedCustomColorFee.length > 0
                                    ) {
                                        order_item["custom_color_fee"] =
                                            parsedCustomColorFee;
                                        break;
                                    }
                                }
                            }
                        }
                    }
                });
            }

            processedOrder.items = order_items;
            processedOrder.total_setup_fee = all_setup_fee;
            return processedOrder;
        }
    }
};
</script>

<style>
.design-history-panel .tooltip-content .tooltip-body {
    max-height: 180px;
    overflow-y: auto;
}
.back-link{
    color: #000 !important;
    font-size: 14px;
    line-height: 14px;
    font-family: 'mulish';
    font-weight: 500;
    text-decoration: none;
}
.back-link img{
    filter: brightness(0);
}
body.my-design{
    overflow: hidden !important;
}
.thumbnail-item{
    position: relative;
}
.thumbnail-dir-label img{
    width: 10px !important;
    height: 10px !important;
        position: absolute;
    top: 6px;
    left: 6px;
}
.history_right_block{
    display: flex;
    align-items: center;
    gap: 10px;
}
.order-header.collapsed  .history_right_block svg{
            transform: rotate(0deg);
        }
        .order-header  .history_right_block svg{
            transform: rotate(180deg);
        }
  .product_art_info p{
    margin-bottom: 0px;
    color: #000000;
    font-size: 10px;
    line-height: 10px;
    font-weight: 600;
  }
  .note_panel{
    background-color: #FFCC004D;
    padding: 9px;
    color: #414141;
    font-weight: 400;
    font-size: 14px;
    line-height: 14px;
  }
  /* Override default thumbnail li sizing (12x12) so "+N" can fit nicely */
  .thumbnail-colors li.more_color_link {
    width: auto !important;
    height: auto !important;
    border: 1px solid #d9d9d9 !important;
    padding: 0 5px !important;
    border-radius: 2px !important;
    display: inline-flex !important;
    align-items: center !important;
    justify-content: center !important;
    background: #ffffff !important;
  }
  .thumbnail-colors li.more_color_link a {
    text-decoration: none !important;
    color: #414141 !important;
    font-size: 10px !important;
    font-weight: 600 !important;
    line-height: 12px !important;
  }
</style>
